<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2008</span></div>
    </div>
    <div class="view-wrap yr2008">


<FullYearStats fullGames='16' fullCompletions='413' fullAttempts='635' fullYards='5,069' fullPct='65.0' fullTDs='34' fullINTs='17' fullYPG='316.8' fullRating='96.2'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      
      <div class="year-summary-text-flex">
      <h1 class="content-headline">Brees takes a big step forward but the team still needed to gel</h1>

      <div class="copy-paragraph">
In 2008, the Saints would drop three of their first five games by an average of 3.3 points per game. They split both halves of the season, going 4-4 before and after the bye week and missing the playoffs for the second straight year.
        <br/><br/>

While the Saints were tops in scoring and passing offense, their rushing attack was 28th in the league and their defense ranked 26th. With injuries to some key weapons, the Saints were never able to truly get going, finishing 8-8, a game better than last year.
<br/><br/>

Brees passed for 5,069 yards (just the second player to reach the 5,000-yard milestone in league record books), 15 short of breaking the record set by Dan Marino in 1984. Drew also passed for 300+ yards in ten games, tying Rich Gannon's 2002 record for most in a season. This was good enough to make Brees the Offensive Player of the Year and send him to his third Pro Bowl of his career.
      <br/><br/>

      
      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2008-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees throwing a pass over a Chicago Bear defender">
      </div>

      <div class="awards-wrapper">
        <div class="awards-headline">2008 Awards</div>
        <ul>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 1st Team All-Pro (SN, SI)</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2nd Team All-Pro (AP)</li>
          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2008 Pro Bowl</li>
          <li><img :src="require('@/assets/ap-award.jpg')" alt="AP Logo"> AP NFL Offensive Player of the Year</li>
          <li><img :src="require('@/assets/sn-logo.png')" alt="Sporting News Logo"> SN Offensive Player of the Year</li>
          <li><img :src="require('@/assets/fedex-air.jpg')" alt="FedEx Logo"> FedEx Air Player of the Year</li>
          <li><img :src="require('@/assets/101-award.png')" alt="101 Awards Logo"> Committee of 101 - NFC Offensive Player of the Year</li>
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pro Football Writers of America Logo"> PFWA All-NFC</li>

          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
    </div>
  </div>


 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2008 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>




<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2008 Touchdown Tally"> 2008 TOUCHDOWN TALLY</h1>
</div>


</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2008 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2008 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2008 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2008 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2008 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2008 - Slide6"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2007">«2007</router-link></div>
  <div class="year-pagination-section year-pagination-current">2008</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2009">2009»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2008',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2008 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2008-top.jpg",
      image1: "brees-2008-slide-1.jpg",
      image2: "brees-2008-slide-2.jpg",
      image3: "brees-2008-slide-3.jpg",
      image4: "brees-2008-slide-4.jpg",
      image5: "brees-2008-slide-5.jpg",
      image6: "brees-2008-slide-6.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2008;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },
   mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},
created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 96.2,
                  y: 316.8,
                  r: 34/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#fff",
        "borderColor": "#002C5F",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 95.0,
                  y: 250.1,
                  r: 27/1.5
                }
              ]
      },
      {
        "label": "Phillip Rivers",
        "backgroundColor": "#0080C6",
        "borderColor": "#FFC20E",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 105.5,
                  y: 250.6,
                  r: 34/1.5
                }
              ]
      },
      {
        "label": "Chad Pennington",
        "backgroundColor": "#008E97",
        "borderColor": "#F26A24",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 97.4,
                  y: 228.3,
                  r: 19/1.5
                }
              ]
      },
      {
        "label": "Kurt Warner",
        "backgroundColor": "#97233F",
        "borderColor": "#f2f2f2",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 96.9,
                  y: 286.4,
                  r: 30/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards Per Game, ' + tooltipItem.xLabel.toLocaleString() + ' QB Rating, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards Per Game'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'QB Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2008.vue